import React from 'react';
import { useSelector } from 'react-redux';
import Logo from '../../images/Logo.png';
import '../../sass/Footer.scss';
import WhatsappComponent from '../utils/WhatsappComponent';


const Footer = () => {

    
    const puntosContacto = useSelector(state => state.puntosContacto);
    const currentYear = new Date().getFullYear();
    
    
    
    
    //const fraseAsistente = enlaces.find(w => w.Id === "WHATSAPP_FRASE")?.URL === undefined ? "Hola! 👋 Estoy " : enlaces.find(w => w.Id === "WHATSAPP_FRASE")?.URL;
    


    return (
        <>
            

            <WhatsappComponent />

            <footer>

                <div className="container-footer">
                    <div className="row">
                        {
                            puntosContacto.find(w => w.Id === "ATC") &&
                            <>
                                <div className="col-lg-3">
                                    <h4 className="subtitle">{puntosContacto.find(w => w.Id === "ATC").Nombre}</h4>
                                    <p>Teléfono: {puntosContacto.find(w => w.Id === "ATC").Telefono}<br />
                                        {puntosContacto.find(w => w.Id === "ATC").Correo}
                                    </p>
                                </div>
                            </>
                        }
                        {
                            puntosContacto.find(w => w.Id === "RES") &&
                            <>
                                <div className="col-lg-3">
                                    <h4 className="subtitle">{puntosContacto.find(w => w.Id === "RES").Nombre}</h4>
                                    <p>Teléfono: {puntosContacto.find(w => w.Id === "RES").Telefono}<br />
                                        {puntosContacto.find(w => w.Id === "RES").Correo}
                                    </p>
                                </div>
                            </>
                        }

                        <div className="col-lg-3"></div>
                        <div className="col-lg-3 brand">
                            <br />
                            <img className="brand-image" src={Logo} alt="..." />
                            <br />
                            <p>{currentYear} © InterAmerican Car Rental</p>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <p className="design-tag"><a href="https://onesolutionsgroup.com/">Diseñado por One Solutions</a></p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}


export default Footer
